import jsPDF from "jspdf";
import "jspdf-autotable";
// Date Fns is used to format the dates we receive
// from our API call
import { format } from "date-fns";

// define a generatePDF function that accepts a tickets argument
const generatePDF = agencyReport => {
  // initialize jsPDF
//   const doc = new jsPDF();
var doc = new jsPDF('l', 'mm', 'a4');
var d =      format(new Date(), "yyyy-MM-dd")
;
  // define the columns we want and their titles
  const tableColumn = ["Agency Name", "Agency Email", "License Count", "Convenience Fee", "Kennel Count","Total Payment","Customer Count","Created Date" ];
  // define an empty array of rows
  const tableRows = [];

  // for each report pass all its data into an array
  agencyReport.forEach(report => {
    const ticketData = [
      report.agencyName,
      report.agencyEmail,
      report.licenseCount==null?"-":report.licenseCount,
      report.convenienceFee==null?"-":report.convenienceFee,
      report.kennelLicenceCount==null?"-": report.kennelLicenceCount,
      report.totalPayment==null?"-":report.totalPayment,
      report.customerCount==null?"-": report.customerCount,

      // called date-fns to format the date on the report
      format(new Date(report.createdDate), "yyyy-MM-dd")
    ];
    // push each tickcet's info into a row
    tableRows.push(ticketData);
  });


  // startY is basically margin-top
  doc.autoTable(tableColumn, tableRows, { startY: 20 });
  // we use a date string to generate our filename.
  // report title. and margin-top + margin-left
  doc.text("Agency Report_"+d, 14, 15);
  // we define the name of our PDF file.
  doc.save(`Agency_report_${d}.pdf`);
};

export default generatePDF;